import { AuthBindings } from "@refinedev/core";
import { AuthHelper } from "@refinedev/strapi-v4";
import axios from "axios";

import { API_URL, TOKEN_KEY } from "./constants";

export const axiosInstance = axios.create();
export const apiURL = API_URL + "/api";
export const strapiAuthHelper = AuthHelper(apiURL);

export const authProvider: AuthBindings = {
  login: async ({ email, password }) => {
    const { data, status } = await strapiAuthHelper.login(email, password);
    if (status === 200) {
      const userDetails = await strapiAuthHelper.me(data.jwt, {
        meta: {
          populate: ["role"],
        },
      });
      if (userDetails?.data?.role?.name === "Teacher") {
        localStorage.setItem(TOKEN_KEY, data.jwt);

        // set header axios instance
        axiosInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.jwt}`;

        return {
          success: true,
          redirectTo: "/",
        };
      } else {
        return {
          success: false,
          error: {
            message: "Login failed",
            name: "Only Teachers can login",
          },
        };
      }
    }
    return {
      success: false,
      error: {
        message: "Login failed",
        name: "Invalid email or password",
      },
    };
  },
  logout: async () => {
    localStorage.removeItem(TOKEN_KEY);
    return {
      success: true,
      redirectTo: "/login",
    };
  },
  onError: async (error) => {
    // eslint-disable-next-line
    return { error };
  },
  check: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      error: {
        message: "Check failed",
        name: "Token not found",
      },
      logout: true,
      redirectTo: "/login",
    };
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      return null;
    }

    const { data, status } = await strapiAuthHelper.me(token);
    if (status === 200) {
      const { id, username, email } = data;
      return {
        id,
        name: username,
        email,
      };
    }

    return null;
  },
  forgotPassword: async ({ email }) => {
    const res = await fetch(`${apiURL}/auth/forgot-password`, {
      method: "POST",
      body: JSON.stringify({ email }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();

    if (data.ok) {
      alert("Check your email for a reset link");
      return {
        success: true,
      };
    }

    return {
      success: false,
      error: {
        name: "Forgot Password Error",
        message: "Invalid email or password",
      },
    };
  },
  updatePassword: async ({ password, confirmPassword, code }) => {
    const res = await fetch(`${apiURL}/auth/reset-password`, {
      method: "POST",
      body: JSON.stringify({
        password,
        passwordConfirmation: confirmPassword,
        code,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();

    alert("Password updated successfully");

    if (data?.jwt) {
      return {
        success: true,
        redirectTo: "/login",
      };
    }

    return {
      success: false,
      error: {
        name: "Update Password Error",
        message: "Code is invalid or expired",
      },
    };
  },
};
